import toastMessage from '@/components/Toast';

// utils/toastOnce.ts
let toastLock = false;

export function toastSuccessOnce(message: string, duration = 2000) {
  if (toastLock) return;
  toastLock = true;

  toastMessage.success(message);

  setTimeout(() => {
    toastLock = false;
  }, duration);
}
